import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Modal  from "@react/shared/ui/Modal"
import Button from "@react/shared/ui/Button"
import Input  from "@react/shared/ui/Input"
import ClientSitePicker from "./ClientSitePicker"

const DuplicateQuoteModal = ({ isOpen, onClose, quote, onSubmit }) => {
  const [title,  setTitle]  = useState("")
  const [client, setClient] = useState(null)
  const [site,   setSite]   = useState(null)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (!isOpen || !quote) return
    setTitle(quote.default_duplicate_title || quote.title || "")
    setClient(quote.client || null)
    setSite(quote.site || null)
  }, [isOpen, quote])

  const canSubmit = title.trim() && client && site && !submitting

  const handleConfirm = () => {
    if (!canSubmit) return
    setSubmitting(true)
    onSubmit({
      title:     title.trim(),
      client_id: client.id,
      site_id:   site.id,
    }).finally(() => setSubmitting(false))
  }

  return (
    <Modal
      isOpen   = {isOpen}
      onClose  = {onClose}
      size     = "lg"
      eyebrow  = {quote?.number}
      title    = {I18n.t("button.duplicate")}
      footer   = {
        <>
          <Button variant="ghost" onClick={onClose}>{I18n.t("button.cancel")}</Button>
          <Button variant="primary" onClick={handleConfirm} disabled={!canSubmit}>
            <FontAwesomeIcon icon={submitting ? "spinner" : "copy"} spin={submitting} />
            {I18n.t("button.duplicate")}
          </Button>
        </>
      }
    >
      <div className="space-y-1.5">
        <label className="block text-sm font-medium text-slate-700">
          {I18n.t("quotes.project_index.table.title")}
        </label>
        <Input value={title} onChange={e => setTitle(e.target.value)} />
      </div>

      <ClientSitePicker
        client         = {client}
        site           = {site}
        onClientChange = {setClient}
        onSiteChange   = {setSite}
      />
    </Modal>
  )
}

export default DuplicateQuoteModal
